import BodyExerciseFlow from "@/components/Exercises/Body-Exercise/BodyExerciseFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useChildSessionStore } from "@/lib/stores/childSessionStore";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/body-exercise/"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Traveling Through Your Body - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "stress.exercises.bodyExercise",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const { selectedEmotionId, reset } = useChildSessionStore();
  const navigate = useNavigate();

  const startExercise = () => {
    setShowOverlay(true);
  };

  const handleComplete = () => {
    setShowOverlay(false);
    if (selectedEmotionId) {
      navigate({ to: "/children/session" });
    }
  };

  const handleExit = () => {
    setShowOverlay(false);
    if (selectedEmotionId) {
      reset();
      navigate({ to: "/children/exercises" });
    }
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="bodyExercise.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="bodyExercise.intro.text" />
      </p>
      <BodyExerciseFlow
        onComplete={handleComplete}
        onExit={handleExit}
        isShow={showOverlay}
      />
    </ExerciseLayout>
  );
}
